import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import Users from '../users/Users';
import DashboardCharts from './DashboardCharts';
import './Dashboard.css';

const Dashboard = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderContent = () => {
    switch (currentPage) {
      case 'users':
        return <Users />;
      case 'home':
      default:
        return (
          <div className="content-body">
            <DashboardCharts />
          </div>
        );
    }
  };

  return (
    <main className="main-content">
      <div className="content-wrapper">
        {currentPage !== 'home' && (
          <header className="content-header">
            <h1 className="page-title">
              {currentPage === 'users' && 'Users Management'}
              {currentPage === 'chat-history' && 'Chat History'}
            </h1>
            <p className="page-subtitle">
              {currentPage === 'users' && 'Manage your application users'}
              {currentPage === 'chat-history' && 'View conversation logs and session details'}
            </p>
          </header>
        )}
        {renderContent()}
      </div>
    </main>
  );
};

export default Dashboard; 